import { FC, useEffect, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBackIcon } from '../../../../../components/Icons/ArrowBackIcon';

import styles from './TripPackingPanel.module.scss';
import TripPackingList from '../TripPackingList/TripPackingList';
import { CloseIcon } from '../../../../../components/Icons/CloseIcon';
import FullAccessModal from '../../../../../common/FullAccessModal';
import { useAppSelector } from '../../../../../hooks/redux';

interface TripPackingPanelProps {
  tripId: number;
  stopId?: number;
  onClose: () => void;
}

const TripPackingPanel: FC<TripPackingPanelProps> = ({ tripId, stopId, onClose }) => {
  const isPremium = useAppSelector(state => state.user.is_premium);
  const [openFullAccessModal, setOpenFullAccessModal] = useState(false);

  useEffect(() => {
    if (!isPremium) {
      setOpenFullAccessModal(true);
    }
  }, [isPremium]);

  const handleFullAccessModalClose = () => {
    setOpenFullAccessModal(false);
    onClose();
  };

  return (
    <Box className={styles.tripPackingPanel}>
      <Box className={styles.header}>
        <Box className={styles.headerLeft}>
          <IconButton
            onClick={onClose}
            className={styles.backButton}
            size="small"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h7Bold"
            className={styles.title}
          >
            Packing List
          </Typography>
        </Box>

        <IconButton
          onClick={onClose}
          className={styles.closeButton}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box className={`${styles.content} ${!isPremium ? styles.contentLocked : ''}`}>
        {isPremium ? (
          <TripPackingList
            tripId={tripId}
            stopId={stopId}
            variant="embedded"
          />
        ) : null}
      </Box>

      <FullAccessModal
        open={openFullAccessModal}
        feature="packing_list"
        onClose={handleFullAccessModalClose}
      />
    </Box>
  );
};

export default TripPackingPanel;
